export default "__VITE_ASSET__a97374e0__"